package pwgs.ui.scenes.settingsscene

import pwgs.ui.scenes.generalsettingsscene.GeneralSettingsScene
import pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneProps
import pwgs.ui.scenes.projectinvitations.ProjectInvitationsScene
import pwgs.ui.scenes.projectinvitations.ProjectInvitationsSceneProps
import pwgs.ui.scenes.projectmembersscene.ProjectMembersScene
import pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneProps
import visage.core.Components
import visage.ds.components.page.Page

fun Components.SettingsScene(projectId: Long) = this.registerFunctionalComponent({}) {
    Page {
        head("Settings")
        tab("General") {
            GeneralSettingsScene(GeneralSettingsSceneProps(projectId))
        }
        tab("Members") {
            ProjectMembersScene(ProjectMembersSceneProps(projectId))
        }
        tab("Invitations") {
            ProjectInvitationsScene(ProjectInvitationsSceneProps(projectId))
        }
    }
}